var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenprice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 12.4993H10.8333C11.2754 12.4993 11.6993 12.3238 12.0118 12.0112C12.3244 11.6986 12.5 11.2747 12.5 10.8327C12.5 10.3907 12.3244 9.96673 12.0118 9.65417C11.6993 9.34161 11.2754 9.16602 10.8333 9.16602H8.33333C7.83333 9.16602 7.41667 9.33268 7.16667 9.66602L2.5 14.166",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 17.4993L7.16683 16.3326C7.41683 15.9993 7.8335 15.8326 8.3335 15.8326H11.6668C12.5835 15.8326 13.4168 15.4992 14.0002 14.8326L17.8335 11.1659C18.1551 10.862 18.3428 10.4428 18.3553 10.0006C18.3678 9.55828 18.2041 9.12916 17.9002 8.80758C17.5963 8.48601 17.1771 8.29833 16.7348 8.28582C16.2925 8.27332 15.8634 8.43702 15.5418 8.74092L12.0418 11.9909",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 13.334L6.6665 18.334",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 9.91536C14.6683 9.91536 15.7503 8.83339 15.7503 7.4987C15.7503 6.16401 14.6683 5.08203 13.3337 5.08203C11.999 5.08203 10.917 6.16401 10.917 7.4987C10.917 8.83339 11.999 9.91536 13.3337 9.91536Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66602C6.38071 6.66602 7.5 5.54673 7.5 4.16602C7.5 2.7853 6.38071 1.66602 5 1.66602C3.61929 1.66602 2.5 2.7853 2.5 4.16602C2.5 5.54673 3.61929 6.66602 5 6.66602Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenprice);
export default __webpack_public_path__ + "static/media/tokenprice.b74bd9816eb6f5b590571e35ae9b51c8.svg";
export { ForwardRef as ReactComponent };